import React from 'react';
import { Stepper as KiteStepper } from '@kite-js/core';
import { StepProps } from '@kite-js/core/lib/Stepper/Step';

type GetComponentProps<T> = T extends React.ComponentType<infer P> | React.Component<infer P> ? P : never;

interface StepperStaticProps {
    Step: React.FC<React.PropsWithChildren<StepProps>>;
}

// This file contains temporary exports for components that do not have the children property required for React 18.
// Please delete this file when these components are not used anymore.

export const Stepper = KiteStepper as React.FC<GetComponentProps<typeof KiteStepper>> & StepperStaticProps;
